import React, { useState, useRef, useEffect } from "react";
import { Col, Container, Row, InputGroup, FormControl, ListGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import MainHeader from "../Pages/Header/MainHeader";
import FooterStyle from '../Pages/Footer/Footer';
import { IMAGE_PATHS } from '../Functions/Constant';
import { m } from 'framer-motion';
import ReviewSearch from './ComponentPage/ReviewSearch';
import Loader from './../Components/Loader'

const ReviewPage = () => {
  const navigate = useNavigate();
  const [showSuggestions, setShowSuggestions] = useState(false);
  const searchRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [isMainLoading, setIsMainLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Name");
  const dropdownRef = useRef(null);

  // ** Detect Click Outside Search Box to Hide Suggestions **
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
  
    const handleScroll = () => {
      if (showDropdown) {
        setShowDropdown(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showDropdown]);
  const startLoader = () => {
    setIsMainLoading(true);
  }
  // New function to handle search
  const handleSearch = () => {
    if (searchQuery.trim()) {
      let categoryValue = selectedCategory.toLowerCase();
      if (selectedCategory === "School/College") {
        categoryValue = "school";
      }
      navigate(`/search?query=${encodeURIComponent(searchQuery)}&category=${encodeURIComponent(categoryValue)}`);
      setSearchQuery('');
    }
  };

  // Handle Enter key press
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };
  return (
    <div>
      <MainHeader />
      <m.section className="py-[170px] pb-[0px] overflow-hidden custm-bg  md:py-[75px] sm:py-[50px]">
        
        <Container>
          <Row className="justify-center">
            <Col md={12} className="text-center">
              <h4 className="text-darkgray font-bold">Your Review Helps Others Grow Stronger</h4>
            </Col>
            {/* <Col lg={9} md={10} xs={12} className="text-center flex-col">
                            <h6 className="sm:mb-[30px] text-[18px] text-gray-900">
                                Your feedback helps professionals grow and organizations find the right talent.
                            </h6>
                        </Col> */}
          </Row>

          {/* Search Bar with Dropdown */}
          <Row className="justify-center">
            <Col lg={8} md={10} sm={12} xs={12} className="flex items-center pe-0 xs:!pr-[15px]">
              <div className="w-[100%] flex rounded-full shadow-md bg-white relative overflow-visible leading-[3.2]">

                {/* Search Input */}
                <div className="flex-1 relative">
                  <input
                    type="text"
                    placeholder="Whom would you like to review?"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyDown={handleKeyPress}
                    className="w-full pl-[3.5rem] pr-4 py-2 text-sm text-gray-700 placeholder-gray-400 rounded-l-full custom-placeholder !pt-[17px] xs:!pt-[15px]"
                  />
                  <div className="absolute inset-y-0 left-[1.5rem] flex items-center pointer-events-none">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      className="text-gray-400"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.12 4.14a5.99 5.99 0 1 0 0 11.98 5.99 5.99 0 0 0 0-11.98m-7.49 5.99a7.49 7.49 0 1 1 13.299 4.728L21.37 20.3l-1.06 1.061-5.44-5.44A7.49 7.49 0 0 1 2.63 10.13"
                      />
                    </svg>
                  </div>
                </div>

                {/* Divider Line */}
                <hr className="h-[24px] border border-[#caccd4] relative top-[14px] w-[1px] bg-[#caccd4]" />

                {/* Dropdown Button */}
                <div className="relative flex items-center justify-between px-4 py-2 rounded-r-full w-[23%] md:w-[32%] xs:w-[40%] cursor-pointer" onClick={() => setShowDropdown(!showDropdown)}
                  ref={dropdownRef}>
                  <span className="text-[13px] font-medium text-[#757575]">{selectedCategory}</span>
                  <svg
                    className="w-4 h-4 ml-2 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                  </svg>

                  {showDropdown && (
                    <ul className="absolute top-full right-0 mt-2 w-60 bg-white border border-gray-200 shadow-xl rounded-xl text-sm z-[9999] py-2">
                      {["Name", "Contact", "Company", "School/College", "Location"].map((item) => (
                        <li
                          key={item}
                          className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${item === selectedCategory ? "font-semibold text-gray-600" : ""}`}
                          onClick={() => {
                            setSelectedCategory(item);
                            setShowDropdown(false);
                          }}
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </Col>

          </Row>
        </Container>
        <ReviewSearch bg="bg-white" />
      </m.section>


      <FooterStyle theme="light" className="bg-black text-[#828282] seo-agency-footer_06" logo={`${IMAGE_PATHS.LOGO}`} />

      {
        isMainLoading && (<div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-50 z-50">
          <Loader />
        </div>)
      }

    </div>
  );
};

export default ReviewPage;
